import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
// import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DocumentService } from 'src/app/core/services/document.service';
import { BehaviorSubject, timer } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/timer';
import { take } from 'rxjs/operators';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { Message } from 'src/app/core/class/message';

/**
 * Sign progress component.
 */
@Component({
  selector: 'app-decline-progress',
  templateUrl: './decline-progress.component.html'
})
export class DeclineProgressComponent implements OnInit, OnDestroy {
  
  /**
 * Finish progress value.
 */
  public static FINISH_PROGRESS_VALUE = 100;

  /**
   * stop sign action.
   */
  public static STOP_ACTION = 'stop';

  /**
   * close popup action.
   */
  public static CLOSE_ACTION = 'close';

  /**
   * finish popup action.
   */
  public static FINISH_ACTION = 'finish';

  /**
   * selection action close.
   */
  private selectedActionClose = DeclineProgressComponent.CLOSE_ACTION;

  /**
   * Displayed columns.
   */
  public displayedColumns: string[] = [
    'check',
    'STT',
    'contractName',
    'allName',
    'createdUser',
    'receivedTime'
  ];

  /**
   * The data source of page.
   */
  public dataSource: any;

  /**
   * Slot request timer.
   */
  // private slotRequestTimer: any;

  /**
   * Percent of processing.
   */
  public processedPercent = 0;

  /**
   * length of document.
   */
  public documentCount = 0;

  /**
   * Disable stop sign button.
   */
  public isDisabledStopSignButton = false;

  /**
   * Stream of data that is provided to the table.
   */
  public actions = new BehaviorSubject<string>('');

  isFinished = false;


  constructor(
    // @Inject(MAT_DIALOG_DATA) public data: any,
    // public dialogRef: MatDialogRef<DeclineProgressComponent>,
    // private signOption: string,
    private documentService: DocumentService,
    private dialog: MatDialog,
    public message: Message,
    @Inject(MAT_DIALOG_DATA) public data: {
      isFinished: boolean
    }
  ) {
    this.isFinished = data && data.isFinished;
  }

  /**
   * initialize data.
   */
  ngOnInit() {
    this.dataSource = [];
    this.documentCount = 0;
    let isFirstRun = true;

    this.documentService.declineUpdateAction.subscribe((result) => {
      console.log(result);
      if (!result || !result.res || !result.res.data) {
        this.isDisabledStopSignButton = true;
        return;
      }

      this.isDisabledStopSignButton = this.selectedActionClose === DeclineProgressComponent.STOP_ACTION;
      const rs = result.res;
      const signStatus = result.signStatus;
      const percent = result.percent;

      if (this.dataSource.length === 0 || isFirstRun) {
        isFirstRun = true;
        if (!rs.data.info || !rs.data.contracts) {
          return;
        }

        // initialize list.
        const contracts = JSON.parse(rs.data.contracts);
        // set value of progress.
        if (this.documentCount === 0) {
          this.documentCount = contracts.length;
        }

        const mapContract = {};
        // update status for each document.

        rs.data.info.details.forEach((item) => {
          mapContract[item.contractId] = item;
        });

        contracts.forEach(ct => {
          // let selectedItem = rs.data.info.details.filter((item) => {
          //   if (item.contractId === ct.id) {
          //     return item;
          //   }
          // });

          let selectedItem = mapContract[ct.id];
          if (selectedItem) {
            ct.status = selectedItem.status;
            ct.description = selectedItem.description || this.message.getMessage("messages.decline_fail");
          }
          // ds.push(ct);
        });
        const ds = [...contracts];
        this.dataSource = ds;
      } else {
        // Only update status of datasource, don't update element.
        this.dataSource.forEach(ct => {
          rs.data.info.details.filter((item) => {
            if (item.contractId === ct.id) {
              ct.status = item.status;
              return;
            }
          });
        });
      }

      // update progress of signed document.
      this.processedPercent = percent;

      if (signStatus === DocumentService.SLOT_SIGN_FINISH
        || signStatus === DocumentService.SLOT_SIGN_NO_ACTION) {
        this.isDisabledStopSignButton = true;

        if (signStatus === DocumentService.SLOT_SIGN_FINISH) {
          this.processedPercent = DeclineProgressComponent.FINISH_PROGRESS_VALUE;
        }
      }
    });
    // get slot info first time.
    this.getSlotInfo();
  }

  /**
   * destroy object.
   */
  ngOnDestroy() {
    this.closePopup();
  }

  /**
   * click stop sign button.
   */
  onClickStopSign() {
    // show confirm poup.
    const popup = this.dialog.open(WarningComponent, {
      width: '30%',
      data: 'messages.decline_stop_confirm'
    });

    popup.afterClosed().subscribe(rs => {
      if (rs) {
        // call to server for stopping sign.
        this.isDisabledStopSignButton = true;
        this.selectedActionClose = DeclineProgressComponent.STOP_ACTION;

        this.documentService.stopDecline().subscribe();
        console.log('dataSSSSSSSSSSSS', this.dataSource);
        
      }
    });
  }

  /**
   * close button sign button.
   */
  onClickCloseDialog() {
    this.closePopup();
  }

  /**
   * Load data from data.
   * Format of returned result.
   * {
   *    "info": {
   *      "id": "string",
   *      "createdTime": "DATE",
   *      "cancelTime": "",
   *      "description": "",
   *      "success": false,
   *      "details": [
   *        {
   *          "contractId": "",
   *          "status": 0,
   *          "description": ""
   *        }
   *      ]
   *    },
   *    "contracts": "json string array of contracts"
   * }
   */
  private getSlotInfo() {
    this.documentService.getDeclineApprovalSlotStatus(true, this.isFinished);
  }

  /**
   * close popup.
   */
  private closePopup() {
    if (this.selectedActionClose === DeclineProgressComponent.CLOSE_ACTION) {
      if (this.processedPercent === DeclineProgressComponent.FINISH_PROGRESS_VALUE) {
        this.selectedActionClose = DeclineProgressComponent.FINISH_ACTION;
      }
    }

    this.actions.next(this.selectedActionClose);
  }
}
